export default "__VITE_ASSET__DyjZACLr__"